import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    getBannerHeight,
} from 'src/utils/util';
import {
    SurgeryPanelHeader,
    SurgeryPanelContentContainer,
    Title,
    TitleContainer,
} from './ReceiveSetsHeader.styled';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ReceiveSetsHeader = ({
    selectedAddProductMethod,
    viewSurgeryNotes,
    viewSurgerySuccess,
    isSubmitClicked,
}) => {

    // const bannerLength = useSelector(
    //     (state) => state.loginReducer.bannerLength
    // );
    const { t } = useTranslation();
    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const [requiredMarginBanner, setRequiredMarginBanner] = useState('');

    useEffectWithErrorLogging(() => {
        setRequiredMarginBanner(
            bannerHeight
                ? getBannerHeight(bannerHeight, '7.6rem !important', 8)
                : ''
        );
    }, [bannerHeight]);
    
    return (
        <>
            <SurgeryPanelHeader rquiredMargin={requiredMarginBanner}>
                <SurgeryPanelContentContainer>
                    <TitleContainer
                        width={
                            viewSurgerySuccess
                                ? '100%'
                                : viewSurgeryNotes
                                ? 'auto'
                                : undefined
                        }
                        flexDirection={viewSurgerySuccess ? 'row' : false}
                    >
                        <Title viewSurgeryNotes>
                            <div className="mobile">{t('orders.ordersHeader.inventory')}</div>

                            <div className="web">{t('orders.ordersHeader.inventory')}</div>
                        </Title>
                    </TitleContainer>
                </SurgeryPanelContentContainer>
            </SurgeryPanelHeader>
        </>
    );
};

export default ReceiveSetsHeader;
